import styled, { css } from 'styled-components';
import { FiraSansBold } from 'components/Text';
import Colors from 'constants/Colors';

export const Dialog = styled.div`
  position: fixed;
  z-index: 100;
  padding-top: ${({ forceOnTop }) => forceOnTop ? '3vh' : '30vh'} ;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(255,255,255,0.4);
  display: ${({ canShow }) => canShow ? `block` : `none`};
`;

export const DialogBody = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: ${({ bodyPadding }) => bodyPadding ?? '25px'};
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  width: ${({ width }) => width || '400px'};
  height: auto;
  min-height: 100px;
  border-radius: 4px;
`;

export const DialogIcon = styled.div`
  height: 30px;
  display: block;
  width: 100%;
  ${({ pink }) => pink === "exclamation" ? 
    css`color: ${Colors.PINK};` : css`display: ${Colors.BLACK};`
  }
  font-size: 22px;
  svg{
    float: left;
  }
`;

export const DialogText = styled.p`
  display: block;
  color: ${Colors.GRAY[6]};
  font-weight: ${FiraSansBold};
  font-family: 'Fira Sans', sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  float: left;
  margin: 0px;
  margin-left: 8px;
  margin-top: 1px;
`;